<template>
  <div class="fu-drtab" data-test="fu-drawer-tasks">
    <p v-if="!items.length" class="fu-drtab__empty">No tasks are tagged with this patient.</p>
    <div v-for="it in items" :key="it.key" class="fu-drtab__item" data-test="fu-drawer-task-item">
      <div class="fu-drtab__main">
        <div class="fu-drtab__head">
          <span class="fu-drtab__item-title">{{ it.text }}</span>
          <span v-if="it.status" class="fu-drtab__badge">{{ it.status }}</span>
        </div>
        <div class="fu-drtab__meta">{{ it.meta }}</div>
      </div>
      <a v-if="it.href" class="fu-drtab__view" :href="it.href" target="_blank" rel="noopener">View</a>
    </div>
  </div>
</template>

<script>
/**
 * DrawerTasksTab — today's "Tasks" tab (tasks tagged with the patient, from the tasks store — the
 * container passes them; drawerTabs.withTasksTab puts this tab LAST and only when there are some).
 * Fields as today: createdAt, content, status, createdByEmpID, assignedToEmpID, id → /app/todo/:id.
 * Today renders `content` with v-html; here it is shown as TEXT (tags dropped) — no HTML from a task
 * reaches the drawer. Presentational.
 */
export default {
  name: 'DrawerTasksTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  computed: {
    items() {
      const s = (this.tab.sections || [])[0];
      const c = this.ctx;
      return ((s && s.rows) || []).map((t, i) => {
        const text = String(t.content || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
        const who = [t.createdByEmpID ? `By ${c.employeeName(t.createdByEmpID)}` : '', t.assignedToEmpID ? `for ${c.employeeName(t.assignedToEmpID)}` : '']
          .filter(Boolean).join(' ');
        return {
          key: t.id !== undefined ? t.id : i,
          text: text || 'Task',
          status: t.status || '',
          meta: [t.createdAt ? String(t.createdAt) : '', who].filter(Boolean).join(' · '),
          href: t.id !== undefined && t.id !== null ? `/app/todo/${encodeURIComponent(t.id)}` : '',
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }
.fu-drtab__item { @include fu-dr-item; }
.fu-drtab__main { flex: 1; min-width: 0; }
.fu-drtab__head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.fu-drtab__item-title { @include fu-dr-item-title; }
.fu-drtab__badge { @include fu-pill; }
.fu-drtab__meta { @include fu-dr-item-meta; }

.fu-drtab__view {
  @include fu-focus-ring;
  flex: none;
  font-size: 12.5px;
  font-weight: $fu-fw-semibold;
  color: $fu-link;
  border-radius: $fu-radius-xs;
}
</style>
